import React from 'react';

import classes from './NgzAlreadyparticipant.module.scss';
import { angularizeWithProviders } from '../../../../shared/providers';
import SuccessImage from '../../../../../../assets/images/vectors/success-rounded.svg';

const NgzAlreadyParticipant = () => {
  return (
    <div className={classes.container}>
      <img className={classes.image} src={SuccessImage} alt="success" />
      <div className={classes.textBlock}>
        <h1>You’ve already registered for this challenge</h1>
        <p>Please wait for it to start and track your progress on the leaderboard.</p>
      </div>
    </div>
  );
};

angularizeWithProviders(NgzAlreadyParticipant, 'ngzAlreadyParticipant', {});
